export default __webpack_public_path__ + "static/media/logoHeaderDesktop.dda98ad1.png";